export enum PromptType {
  SPARK_SQL_EXPRESSIONS = 'spark_sql_expressions',
  SPARK_SQL_CODE = 'spark_sql_code',
  PYSPARK_CODE = 'pyspark_code',
} 